export const REFERRER_KEY = "referrer";

export default defineNuxtRouteMiddleware((_, from) => {
  const { setReferrer } = useLocalStorage();

  if (!from.path.startsWith("/auth")) {
    setReferrer(from.path);
  }
});
